<div class="visit-card">
  <div class="row date-range">{{ dateRange }}</div>
  <div class="row reservation-group">
    <div class="header">
      <div id="reservation-info"><i class="icon icon-grid_view"></i>Reservation(s)</div>
      <div>Trainee: {{ traineeName }}</div>
    </div>
  </div>
  <div class="row">
    <ul>
      @for (reservation of reservations; track reservation) {
        <li>{{ reservation?.training?.name }}</li>
      }
    </ul>
  </div>
</div>
